const usCurrency = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
});

export function formatCurrency(amount: number) {
  return usCurrency.format(amount / 100);
}

export default (amount: number) => {
  return `${(amount / 100).toLocaleString("en-US", {
    style: "decimal",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  })}`;
};
